import { useParams } from 'react-router-dom'

import { GoalPageDocument } from 'generated/resources/graphql'

import { observer } from 'mobx-react'

import { useAsyncData } from 'modules/core/hooks/useAsyncData'
import { useQuery } from 'modules/core/hooks/useQuery'

import contractVersions from 'modules/contracts/store/collections/contractVersions'
import { color, message } from 'modules/goals/lib/getGoalBanner'
import goals from 'modules/goals/store/collections/goals'
import goalsConfig from 'modules/goals/store/collections/goalsconfig'
import { ResponsivePage, ResponsivePageBanner } from 'modules/layout/components/ResponsivePage'

import Content from './Content'

const GoalConfigPage = () => {
  const params = useParams()

  const { loading: loadingAsyncData } = useAsyncData(() => {
    return Promise.all([
      goalsConfig.fetch(),
      goals.fetch({
        data: {
          goal_config_id: params.id,
        },
      }),
      contractVersions.fetch({ withCachedFetchParams: true }),
    ])
  }, [params.id])

  const { loading: loadingGraphQl, data } = useQuery(GoalPageDocument)
  const canSeeClockedIn = data?.attendance._policies.companySeeClockedIn.can || false

  const loading = loadingAsyncData || loadingGraphQl

  const goalConfig = goalsConfig.get(Number(params.id))

  if (!goalConfig) {
    return null
  }

  const banner: ResponsivePageBanner = {
    message: message(goalConfig.attributes.status),
    color: color(goalConfig.attributes.status),
    icon: 'info-circle-line',
  }

  return (
    <ResponsivePage.Body
      showHeader={false}
      error={null}
      loading={loading}
      actions={{}}
      banner={banner}
    >
      <Content
        showActions
        goalConfig={goalConfig}
        canSeeClockedIn={canSeeClockedIn}
        contractVersions={contractVersions}
      />
    </ResponsivePage.Body>
  )
}

export default observer(GoalConfigPage)
